import { render } from "./MfittMyTicket.vue?vue&type=template&id=ceb9d676"
import script from "./MfittMyTicket.vue?vue&type=script&lang=js"
export * from "./MfittMyTicket.vue?vue&type=script&lang=js"
script.render = render

export default script